/* RYPT PDP buybox — tier state + section-to-section sync.
   Single source of truth: the pressed card in <rypt-bundle-picker>.
   Selecting a tier:
     1. swaps the pressed state on both cards,
     2. broadcasts `rypt:tier-change` on document (What's Included listens),
     3. syncs the tier into the product form — in quantity mode it updates
        the picker's hidden quantity input; in variant mode it points the
        form's [name="id"] at the tier's variant. */
(() => {
  const TIER_EVENT = 'rypt:tier-change';

  class RyptBundlePicker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const card = event.target.closest('[data-tier-card]');
        if (card && this.contains(card)) this.select(card);
      });
    }

    select(card) {
      this.querySelectorAll('[data-tier-card]').forEach((c) => {
        c.setAttribute('aria-pressed', String(c === card));
      });

      document.dispatchEvent(
        new CustomEvent(TIER_EVENT, {
          detail: {
            tier: card.dataset.tierCard,
            variantId: card.dataset.variantId,
            quantity: card.dataset.quantity,
            productId: this.dataset.productId,
          },
        })
      );

      if (this.dataset.mode === 'quantity') {
        this.syncQuantity(card.dataset.quantity);
      } else {
        this.syncProductForms(card.dataset.variantId);
      }
    }

    // Quantity mode: the picker owns a hidden [name="quantity"] input bound
    // to the product form via the form attribute.
    syncQuantity(quantity) {
      if (!quantity) return;
      const input = this.querySelector('[data-rypt-quantity]');
      if (!input) return;
      input.value = quantity;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Variant mode: point the product form(s) at the tier's variant and fire
    // `change` so the theme updates its displayed price. Scoped to forms
    // whose [name="id"] value belongs to this product's variants.
    syncProductForms(variantId) {
      if (!variantId) return;
      const variantIds = (this.dataset.variantIds || '').split(',');
      document
        .querySelectorAll('form[action*="/cart/add"] [name="id"]')
        .forEach((input) => {
          if (!variantIds.includes(input.value) && input.value !== variantId) return;
          if (input.value === variantId) return;
          input.value = variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
  }

  class RyptWhatsIncluded extends HTMLElement {
    connectedCallback() {
      this.onTierChange = (event) => {
        this.dataset.tier = event.detail.tier;
      };
      document.addEventListener(TIER_EVENT, this.onTierChange);
    }

    disconnectedCallback() {
      document.removeEventListener(TIER_EVENT, this.onTierChange);
    }
  }

  if (!customElements.get('rypt-bundle-picker')) {
    customElements.define('rypt-bundle-picker', RyptBundlePicker);
  }
  if (!customElements.get('rypt-whats-included')) {
    customElements.define('rypt-whats-included', RyptWhatsIncluded);
  }
})();
